import React from 'react';
import { PlayCircleIcon } from 'lucide-react';
type SpeakerPresentation = {
  title: string;
  speaker: string;
  description: string;
  thumbnailUrl: string;
  role: string;
  videoUrl: string;
};
const presentations: SpeakerPresentation[] = [{
  title: 'Syndication Attorney',
  speaker: 'Bethany LaFlam',
  description: 'Bethany discusses securities regulations and options for real estate.',
  thumbnailUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/33wsk7oCJsCJUoZMztSZnB/chrome_TrFW3vGtWy.png',
  role: 'Legal Expert',
  videoUrl: 'https://fathom.video/share/h/FfxyVqH18pf2ZW18gHTfc9KxiriaGzTC'
}, {
  title: 'Self-Directed IRA Strategies',
  speaker: 'Nate Hare',
  description: 'Learn about leveraging self-directed IRAs for real estate investment.',
  thumbnailUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pQ13uTd5XQm98SQEJFbgJ2/chrome_aNXjz9xyqB.png',
  role: 'Directed IRA Specialist',
  videoUrl: 'https://fathom.video/share/h/FHvuef3y3p6QuUVMhV5y8jSx-c4ZGXx2'
}, {
  title: 'Whole Life Liquidity Strategies',
  speaker: 'Donald Pearson',
  description: 'Don explains four key risks and complexities of fixed income bond investing',
  thumbnailUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jP8GQfFC5zXbwczriDxNMj/image.png',
  role: 'WestPac Wealth Partners',
  videoUrl: 'https://fathom.video/share/h/wxzLm9nsyA6HrRvstcp44PJyY2QUVe36'
}];
export function PartnersSection() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-900" data-id="element-143">
      <div className="max-w-7xl mx-auto" data-id="element-144">
        <div className="text-center mb-12" data-id="element-145">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4" data-id="element-146">
            Featured Presentations
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-147">
            Learn from subject matter experts who have successfully leveraged
            real estate for true financial freedom.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-148">
          {presentations.map((presentation, index) => <div key={index} className="bg-black rounded-lg overflow-hidden border border-gray-800 hover:border-[#4a7c59] transition-colors duration-300" data-id="element-149">
              <a href={presentation.videoUrl} target="_blank" rel="noopener noreferrer" className="block" data-id="element-150">
                <div className="relative" data-id="element-151">
                  <img src={presentation.thumbnailUrl} alt={`${presentation.title} Presentation`} className="w-full h-48 object-cover" data-id="element-152" />
                  <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center" data-id="element-153">
                    <PlayCircleIcon className="w-12 h-12 text-white opacity-80 hover:opacity-100 cursor-pointer" data-id="element-154" />
                  </div>
                </div>
                <div className="p-6" data-id="element-155">
                  <h3 className="text-xl font-bold mb-2" data-id="element-156">
                    {presentation.title}
                  </h3>
                  <div className="mb-4" data-id="element-157">
                    <p className="text-[#4a7c59] font-semibold" data-id="element-158">
                      {presentation.speaker}
                    </p>
                    <p className="text-gray-400 text-sm" data-id="element-159">{presentation.role}</p>
                  </div>
                  <p className="text-gray-300 text-sm" data-id="element-160">
                    {presentation.description}
                  </p>
                  <div className="mt-4 text-[#4a7c59] hover:text-white font-semibold text-sm flex items-center" data-id="element-161">
                    Presentation Highlight
                    <PlayCircleIcon className="w-4 h-4 ml-2" data-id="element-162" />
                  </div>
                </div>
              </a>
            </div>)}
        </div>
        <div className="mt-12 text-center" data-id="element-163">
          <a href="/presentations" className="bg-[#4a7c59] hover:bg-[#3d6649] text-white font-bold py-3 px-8 rounded-md inline-block" data-id="element-164">
            View All Presentations
          </a>
        </div>
      </div>
    </section>;
}